"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtDelete = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtDelete = function SvgBtDelete(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.726 7.71594H16.2571V7.38782C16.2571 6.62256 15.6345 6 14.8691 6H13.1569C12.3916 6 11.7689 6.62256 11.7689 7.38782V7.71594H10.3C9.0835 7.71594 8.09375 8.70569 8.09375 9.92224V10.8441C8.09375 11.103 8.30359 11.3129 8.5625 11.3129H8.74768V20.6124C8.74768 21.3776 9.37012 22 10.1351 22H17.8909C18.6559 22 19.2783 21.3776 19.2783 20.6124V11.3129H19.4635C19.7224 11.3129 19.9323 11.103 19.9323 10.8441V9.92224C19.9323 8.70569 18.9425 7.71594 17.726 7.71594V7.71594ZM12.7064 7.38782C12.7064 7.13953 12.9084 6.9375 13.1569 6.9375H14.8691C15.1176 6.9375 15.3196 7.13953 15.3196 7.38782V7.71594H12.7064V7.38782ZM9.03125 9.92224C9.03125 9.22253 9.60046 8.65344 10.3 8.65344H17.7261C18.4257 8.65344 18.9949 9.22253 18.9949 9.92224V10.3754H9.03125V9.92224ZM18.3409 20.6124C18.3409 20.8606 18.139 21.0625 17.8909 21.0625H10.1351C9.88708 21.0625 9.68518 20.8606 9.68518 20.6124V11.3129H18.3409V20.6124Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.4114 19.4247C16.6702 19.4247 16.8801 19.2148 16.8801 18.9559V13.4189C16.8801 13.16 16.6702 12.9502 16.4114 12.9502C16.1525 12.9502 15.9426 13.16 15.9426 13.4189V18.9559C15.9426 19.2148 16.1525 19.4247 16.4114 19.4247Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.0131 19.4247C14.2719 19.4247 14.4818 19.2148 14.4818 18.9559V13.4189C14.4818 13.16 14.2719 12.9502 14.0131 12.9502C13.7542 12.9502 13.5443 13.16 13.5443 13.4189V18.9559C13.5443 19.2148 13.7542 19.4247 14.0131 19.4247Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.6147 19.4247C11.8735 19.4247 12.0835 19.2148 12.0835 18.9559V13.4189C12.0835 13.16 11.8735 12.9502 11.6147 12.9502C11.3558 12.9502 11.146 13.16 11.146 13.4189V18.9559C11.146 19.2148 11.3558 19.4247 11.6147 19.4247Z",
    fill: "currentColor"
  }));
};

exports.SvgBtDelete = SvgBtDelete;